import {
  Box,
  Container,
  Typography,
} from "@mui/material";

import { motion } from "framer-motion";
import logo from "../../assets/logo/logotipo.png"
import banner from "../../assets/img/antilllen.png";

export const HeroContacto = () => {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        minHeight: { xs: 500, md: 620 },
        display: "flex",
        alignItems: "center",
        background:
          "linear-gradient(135deg,#fafbfd 0%,#f5f7fb 100%)",
      }}
    >
      {/* Imagen de fondo */}
      <Box
        component="img"
        src={banner}
        alt="Colegio"
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          width: { xs: "100%", md: "55%" },
          height: "100%",
          objectFit: "cover",
          opacity: .28,
          zIndex: 1,
        }}
      />

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg,#ffffff 0%,rgba(255,255,255,.96) 40%,rgba(255,255,255,.72) 100%)",
          zIndex: 2,
        }}
      />

      {/* Círculo rojo */}
      <Box
        sx={{
          position: "absolute",
          width: 420,
          height: 420,
          borderRadius: "50%",
          background: "#8f1515",
          left: -220,
          top: 120,
          opacity: .08,
          zIndex: 1,
        }}
      />

      {/* Círculo azul */}
      <Box
        sx={{
          position: "absolute",
          width: 320,
          height: 320,
          borderRadius: "50%",
          background: "#484A75",
          right: -140,
          bottom: -120,
          opacity: .08,
          zIndex: 1,
        }}
      />

      {/* Cuadritos decorativos */}
      <Box
        sx={{
          position: "absolute",
          top: 70,
          left: 60,
          width: 80,
          height: 80,
          backgroundImage:
            "radial-gradient(#cfcfcf 1.5px, transparent 1.5px)",
          backgroundSize: "12px 12px",
          opacity: .6,
          zIndex: 2,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 5 }}>
        <motion.div
          initial={{ opacity: 0, y: 45 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .8 }}
        >
          <Box
  sx={{
    maxWidth: 760,
    mx: "auto",
    textAlign: "center",
  }}
>
  {/* Logo */}
  <Box
    component={motion.div}
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 0.15, duration: 0.6 }}
    sx={{
      width: { xs: 110, md: 140 },
      height: { xs: 110, md: 140 },
      borderRadius: "50%",
      background: "transparent",
      
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      mx: "auto",
      mb: 4,

    }}
  >
    <Box
      component="img"
      src={logo}
      alt="Logo Colegio"
      sx={{
        width: "78%",
        height: "78%",
        objectFit: "contain",
      }}
    />
  </Box>

  <Typography
    sx={{
      fontWeight: 700,
      fontSize: {
        xs: "2.3rem",
        md: "3rem",
      },
      color: "#172554",
      lineHeight: 1.1,
      letterSpacing: "-1px",
    }}
  >
    COMUNÍCATE CON
    <br />
    <Box
      component="span"
      sx={{
        color: "#8f1515",
      }}
    >
      NOSOTROS
    </Box>
  </Typography>

  <Box
    sx={{
      width: 90,
      height: 5,
      borderRadius: 999,
      background: "linear-gradient(90deg,#8f1515,#c69ba5)",
      mx: "auto",
      mt: 3,
      mb: 4,
    }}
  />

  <Typography
    sx={{
      color: "#5f6368",
      fontSize: {
        xs: 17,
        md: 22,
      },
      lineHeight: 1.3,
      maxWidth: 700,
      mx: "auto",
    }}
  >
    Nuestro equipo está disponible para orientarte en procesos de{" "}
    <Box
      component="span"
      sx={{
        color: "#8f1515",
        fontWeight: 700,
      }}
    >
      admisión, matrículas
    </Box>{" "}
    y{" "}
    <Box
      component="span"
      sx={{
        color: "#484A75",
        fontWeight: 700,
      }}
    >
      oportunidades laborales.
    </Box>

    <br />

    Selecciona la opción que necesitas y te entregaremos toda la información.
  </Typography>
</Box>
        </motion.div>
      </Container>
    </Box>
  );
};